<!-- eslint-disable @angular-eslint/template/no-call-expression -->

@if (showMobileNav()) {
  <app-mobile-menu [navItems]="navItems" />
}

@if (showHeader()) {
  <app-header
    [menuItems]="menuItems()"
    [isTrustpilotEnabled]="isTrustpilotEnabled()"
    [locale]="locale"
    (resetForm)="resetForm()"
  />
}

<div class="content" [class.white-space-navbar]="showMobileNav() && !showWzbFooter()">
  <router-outlet />
</div>
@if (showWzbFooter()) {
  <wiz-footer
    class="footer"
    [class.white-space-navbar]="showMobileNav()"
    [class.footer--helps-list]="isHelpsRoute"
    [attr.contactmodalprovider]="contactModalProvider"
    [attr.appid]="appId"
    [attr.hosturl]="'/'"
    [attr.rounded]="true"
    [attr.apidomain]="footerApiDomain"
    [attr.accountapiurl]="accountApiUrl"
    [attr.contactemailkey]="this.defaultEmailKey()"
    [attr.currentlocale]="locale"
  >
    <span class="usefull-links" slot="wzbFooterListInside">
      @if (blogAdvicesEnabled()) {
        <li>
          <a
            [href]="baseHref + FeaturesRoutingEnum.Advices"
            (click)="trackEvent('Footer', 'Click conseils')"
            i18n="@@money.footer.advices"
            >Nos conseils
          </a>
        </li>
      }
      @if (blogFinancialAidEnabled()) {
        <li>
          <a
            [href]="baseHref + FeaturesRoutingEnum.HelpsListing"
            (click)="trackEvent('Footer', 'Click Toutes les aides')"
            i18n="@@money.footer.helps-directory"
            >Annuaire des aides
          </a>
        </li>
      }
      @if (blogAdvicesEnabled()) {
        <li>
          <a
            [href]="baseHref + FeaturesRoutingEnum.Authors"
            (click)="trackEvent('Footer', 'Click Annuaire des auteurs')"
            i18n="@@money.footer.authors-directory"
            >Annuaire des auteurs
          </a>
        </li>
      }
      @if (blogFaqEnabled()) {
        <li>
          <a
            [href]="baseHref + FeaturesRoutingEnum.Faq"
            (click)="trackEvent('Footer', 'Click FAQ')"
            i18n="@@money.footer.faq"
            >FAQ
          </a>
        </li>
      }
    </span>
  </wiz-footer>
}
